import { Table } from "semantic-ui-react";

import { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { usePutFarmGateProcessData } from "../../../../api/cultivations";
import { usePutProcessGateProcessData } from "../../../../api/process";
import { TitleView } from "../../../../components";
import { GateType, WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../config/constants";
import { contentEdit } from "./ProcessContent";

const ProcessData = ({ reviewData, isEditable, refetch }: any) => {
  const [selectProcess, setSelectProcess] = useState<any>(null);
  const [inputUnitTypes, setInputUnitTypes] = useState<any>(WEIGHT_UNIT_TYPES_OPTIONs[0]);
  const [outputUnitTypes, setOutputUnitTypes] = useState<any>(WEIGHT_UNIT_TYPES_OPTIONs[0]);

  const { mutate: putProcessGateProcessData, isLoading: isUpdateProcessLoading } =
    usePutProcessGateProcessData();

  const { mutate: putFarmGateProcessData, isLoading: isUpdateFarmGateLoading } =
    usePutFarmGateProcessData();

  const values = useMemo(() => {
    return selectProcess;
  }, [selectProcess]);

  const {
    formState: { errors },
    control,
    handleSubmit,
    reset
  } = useForm({ defaultValues: values, values: values });

  const processData = useCallback(
    (currnetData: any, processStatus: any) => {
      return (
        currnetData
          ?.map((process: any) => {
            const processOrFarmGateName = process?.[processStatus] || "";
            const processDetails = process?.processing || [];
            const processData: any[] = [];
            if (processDetails.length === 0) return null;
            for (let i = 0; i < (processDetails?.length || 0); i++) {
              let processDataItem = processDetails[i];
              processDataItem.processOwnId = process?._id;
              processData.push(processDataItem);
            }

            return {
              processOrFarmGateName,
              gateType:
                processStatus === "processGateName" ? GateType.ProcessGate : GateType.FarmGate,
              processData
            };
          })
          .filter(Boolean) || []
      );
    },
    [reviewData]
  );

  const processDetails = useMemo(() => {
    const processGate = processData(reviewData?.processGate || [], "processGateName");
    const FarmGate = processData(reviewData?.farmGate || [], "farmGateName");
    return [...processGate, ...FarmGate];
  }, [reviewData]);

  return (
    <>
      <TitleView CustomTitleViewMain="mt-2" title="Process (Process and Farm Gate)" />
      <Table celled className="table" structured>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="tableHeader" colSpan="" textAlign="center">
              Process (Process and Farm Gate)
            </Table.HeaderCell>
            <Table.HeaderCell
              className="tableHeader"
              colSpan="15"
              textAlign="center"
              style={{ backgroundColor: "#f4c6db", color: "#000" }}
            >
              Input field
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell className="tableHeaderReview">Gate</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Processing Name</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Capacity (input/hr)</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Input</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Output</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">Bio waste/side stream</Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">
              Electricity (per input amount)
            </Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">
              Water (per input amount)
            </Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview">
              Heat (per input amount)
            </Table.HeaderCell>
            <Table.HeaderCell className="tableHeaderReview" />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {processDetails.map((processDetails: any, dataIndex: number) => {
            const processOrFarmGateName = processDetails?.processOrFarmGateName;
            const gateType = processDetails?.gateType;
            const processDataArray = processDetails?.processData || [];

            let renderedRows: JSX.Element[] = [];
            let currentRow = 0;

            for (let groupIndex = 0; groupIndex < processDataArray.length; groupIndex++) {
              const data: any = processDataArray[groupIndex];

              const inputUnit = WEIGHT_UNIT_TYPES_OPTIONs.find(
                (e: any) => e.key === data?.inputUnit
              );
              const outputUnit = WEIGHT_UNIT_TYPES_OPTIONs.find(
                (e: any) => e.key === data?.outputUnit
              );
              const rowLength = processDataArray.length;
              renderedRows.push(
                contentEdit(
                  dataIndex,
                  groupIndex,
                  currentRow,
                  rowLength,
                  processOrFarmGateName,
                  gateType,
                  data,
                  inputUnit,
                  selectProcess,
                  control,
                  errors,
                  setSelectProcess,
                  inputUnitTypes,
                  setInputUnitTypes,
                  outputUnitTypes,
                  setOutputUnitTypes,
                  handleSubmit,
                  putProcessGateProcessData,
                  isUpdateProcessLoading,
                  putFarmGateProcessData,
                  isUpdateFarmGateLoading,
                  outputUnit,
                  refetch,
                  reset,
                  isEditable
                )
              );

              currentRow++;
            }
            return renderedRows;
          })}
        </Table.Body>
      </Table>
    </>
  );
};

export default ProcessData;
